<template>
    <div>
        <div class="sa-coment-box" v-if="review">{{formatedReview}}</div>
        <div class="sa-coment-apnt" v-if="review.length > 280">
            <slot name="app-details"></slot>
            <button class="sa-btn sa-coment-btn" v-if="review.length > 280"  @click="showFullReview = !showFullReview" >{{ showFullReview ? 'Read Less' : 'Read Full'  }}</button>
        </div>
    </div>   
</template>
<script>
export default {
    props: {
        review: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showFullReview: false,
        }
    },
    computed:{
      formatedReview(){
          if(this.showFullReview) return this.review
          if(this.review.length > 280)
          return this.review.slice(0,280) + '...';
          else return this.review
      }
  }
}
</script>